import EditAssemblyMaterials from './EditAssemblyMaterials';

export default EditAssemblyMaterials;